<template>
    <TVJoyDialog>
        <template #dialog-header>{{ $t('projectclient.quote.view.quote-summary.dialog.punchout.title', {0: erpName}) }}</template>

        <template #dialog-body>
            <VJoyHighlight class="joy-mb-4" level="warning" display-icon icon="warning-triangle">
                <span v-html="t('projectclient.quote.view.quote-summary.dialog.punchout.highlight', {0: escapeHtml(erpName)})" />
            </VJoyHighlight>

            <p>{{ $t('projectclient.quote.view.quote-summary.dialog.punchout.share-url', {0: erpName}) }}</p>
            <VJoyWrapper no-margin item-stretch>
                <VJoyInput :readonly="true" name="erpInput" :placeholder="linkToCopy" />
                <VJoyButton
                    class="copy-button"
                    variant="secondary"
                    :label="t('projectclient.quote.view.quote-summary.dialog.punchout.action.copy')"
                    @click="handlyCopyLink"
                />
            </VJoyWrapper>
        </template>

        <template #dialog-confirm>
            <VJoyButton variant="ghost" @click="closeDialog">{{ $t('general.cancel') }}</VJoyButton>
            <VJoyButton variant="main" :loading="loading" icon="external-link" icon-position="right" @click="handleConnectToErp">
                {{ $t('projectclient.quote.view.quote-summary.dialog.punchout.action.connect', {0: erpName}) }}
            </VJoyButton>
        </template>
    </TVJoyDialog>
</template>

<script setup lang="ts">
    import {ref, computed} from 'vue';
    import {useTranslation} from '#imports';
    import {copyToClipboard} from '@malt/dom';
    import {escapeHtml} from '@malt/sanitize';
    import {VJoyButton, VJoyHighlight, VJoyInput, VJoyWrapper, pushVJoySnackbar} from '@maltjoy/core-vue';
    import {useDialogRoot} from '~/common/composables';

    const props = defineProps<{
        quoteId: string;
        erpUrl?: string;
        erpName?: string;
    }>();

    const {t} = useTranslation();

    const loading = ref(false);

    const {TVJoyDialog, closeDialog} = useDialogRoot();

    const linkToCopy = computed(() => window.location.href);

    function handlyCopyLink() {
        copyToClipboard(linkToCopy.value);
        pushVJoySnackbar({props: {message: t('projectclient.quote.view.quote-summary.dialog.punchout.action.copy.success'), level: 'success'}});
    }

    function handleConnectToErp() {
        loading.value = true;
        if (props.erpUrl) {
            window.open(props.erpUrl, '_blank');
        }
        loading.value = false;
    }
</script>

<style lang="scss" scoped>
    .copy-button {
        padding: 0;
    }
</style>
